import React, { Component } from 'react';
import { Select, Pagination } from 'antd';
import '../styles/Dashboard.scss';

export default class PaginationComponent extends Component {

    render() {
        const { Option } = Select;
        const { handlePageSizeChange, pageSize, showPageSize, onPaginationChange, total } = this.props;

        return (
            <section style={{ background: '#1890ff', padding: '10px 40px 40px 0px' }}>

                {showPageSize &&
                    <span style={{ float: 'left' }}><span style={{ marginLeft: '20px', marginRight: '20px', color: '#ffffff' }}>Entries per page </span>
                        <Select style={{ width: 80 }} defaultValue="20" onChange={(value) => handlePageSizeChange(value)} className="page-size-select">
                            <Option value="10">10</Option>
                            <Option value="20">20</Option>
                            <Option value="30">30</Option>
                            <Option value="40">40</Option>
                            <Option value="50">50</Option>
                        </Select>
                    </span>
                }
                <span style={{ float: 'right' }}><Pagination defaultCurrent={1} total={total} pageSize={pageSize ? pageSize : 0} onChange={(item) => onPaginationChange(item)} /></span>

            </section>
        )
    }
}
